module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER TWO")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("H"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("AD SHE")])]), _vm._v(" been too hard?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elizabeth fretted over the question as she headed towards Nathan’s quarters. She had never considered Sam fragile, more a fighter, a survivor against any odds, always bouncing back with a stubborn determination to win out in the end. But she was fighting the wrong fight with Tommy. And sometimes, Elizabeth firmly told herself, one had to be cruel to be kind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All the same, it troubled her that Sam had looked so…"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vulnerable.")]), _vm._v(" Somehow it evoked the sense of its being make or break time for these two—the son who could always make her laugh and lift her spirits, and the child-girl-woman who’d become a thorn in his side instead of the smile in his heart. What should have turned out right for both of them had taken a wrong twist and Elizabeth wasn’t sure if her interference could correct it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("After years of observing them at loggerheads, she had come to the conclusion that pride wouldn’t allow them to change their attitudes. Maybe it was too late and the mutual sniping had killed what might have been. Laid it to waste. She’d tried to tell them, lecturing them on lost opportunities, time going past that could never be regained, but to no avail. If she ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("couldn’t jolt them into a new awareness of each other at this wedding…well, at least she would have tried.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ultimately, they were responsible for their own happiness. The problem was—Elizabeth no longer trusted them to make it happen themselves. Not that she could make it happen, either. All she could do was push.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nathan wasn’t in his room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Tommy’s was vacant, as well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She found all three of her sons sitting at the bar in the billiard room, Jared, her youngest, pouring champagne into glasses. In their formal black tie wedding attire, each one of them was strikingly handsome, though quite individual in their looks; Nathan so big and tall and strong and impressively male, with the bluest of blue eyes and straight black hair, almost the image of his father; Tommy, with his endearing, untameable tight black curls, and wickedly charming brown eyes, always the flash of a mischievous devil about him; and Jared, having a less obvious strength, a quieter charm, his eyes darkly serious and always receptive, just a wave in his black hair, subtly providing a balance between the other two.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("For several moments Elizabeth stood still, enjoying her pride in them. Lachlan would be proud of them, too, she thought, wishing her husband was still alive and at her side today, celebrating the wedding of his firstborn. His boys were all men now, men in their own right and pursuing their chosen paths, and it did Elizabeth’s heart good to see them so happily ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("at ease with each other, enjoying a togetherness they rarely had time to share.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought you would have all had more than enough to drink at last night’s buck’s party,” she remarked, finally drawing their attention.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just a last toast to the end of my bachelorhood,” Nathan excused with a grin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Settling his nerves,” Jared teased.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I, for one, definitely need fortification,” Tommy declared. “Any man who partners Sam has to be fighting fit, and since I’ve been elected…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You could give it a break, Tommy,” Nathan suggested. “Treat Sam like a lady instead of a sparring partner. Then she’d have nothing to hit off.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elizabeth flashed her eldest son a grateful look, pleased to have a ready ally.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sam, a lady?” Tommy’s mouth curled into a mocking smile. “First, she wouldn’t know how to respond. Second, she’d accuse me of sending her up. Or she’d suspect me of some nefarious motive and see everything I did and said as a trap which I’d somehow spring on her when she’d most hate it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He swept out an arm, gesturing to Elizabeth, his eyes beaming warm admiration. “Now, there you see a real lady. And may I say you look wonderful, Mum. Doing Nathan proud today.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, Tommy. And I happen to think Samantha will do you proud…if you let her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Samantha?” His eyebrows shot up. “Since when has Sam become Samantha?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’ll see,” Elizabeth replied knowingly, piquing curiosity.")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“A glass of champagne for you, Mum?” Jared asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, thank you. I just came to check that you’re all ready and nothing’s amiss.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do we pass inspection?” Nathan asked with an amused, confident smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a moment, he reminded her so strongly of Lachlan on their wedding day, she choked up, nodding her approval to cover the emotional block.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What am I going to see?” Tommy drawled, his voice laced with scepticism. “Has Miranda waved some magic wand over Sam?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Could I have a private word with you, Tommy?” Elizabeth asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ve got the ring.” He patted his trouser pocket. “I know all the duties of a best man. You can trust me to carry them out. And despite whatever barbs Sam chooses to sling at me, my speech thanking the bridesmaid will be all you’d want it to be. Does that cover it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not quite. Please…just a few minutes of your time,” Elizabeth insisted, gesturing to the adjoining lounge room.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With a much put-upon roll of his eyes, he heaved himself off the bar stool, then wickedly broke into a song and dance. “‘Oh, we’re going to the cha-a-apel, going to get ma-a-arried…”’ And to his brothers’ huge merriment, swept Elizabeth into a dance hold and whirled her into the adjoining room with all the panache of the playboy image he’d cultivated.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("And what did that cover? Elizabeth had often wondered. She didn’t believe he had a lust for many ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("women. To her mind, it was more a restless search for someone to answer needs that Sam wouldn’t or couldn’t answer. Or a pride thing, proving other women found him readily desirable. But it wasn’t giving him what he truly wanted. Elizabeth was certain of that.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“So…” he said, bringing her to a halt beyond ready earshot of the others. “…what’s on your mind?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She caught her breath, wishing she didn’t have to dampen the devilish twinkle in his eyes. But she loved Tommy too much to let him hide his deep-down needs behind a wall of frivolous fun.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Nathan’s wedding day,” she started.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He made a mock frown. “I truly am aware of that fact.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes…well, I’d like it to be a very happy occasion. No bickering or snide little cracks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He raised his eyebrows in a show of innocence. “I am the very soul of pleasure on tap.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then show that soul to Samantha for once, Tommy. You heard Nathan. He won’t ask it directly of you but I shall. Give the fighting a break. Be kind, generous…”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face closed up.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Tommy, I am just asking you to treat her as you would any other woman. Don’t mess this up.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Mess what up?” he demanded coldly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This day. You’re older than she is. And God knows you’ve had enough experience of women to handle the situation with finesse. She’s nervous. She’s afraid…”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Afraid?” His eyes flashed derision. “Sam’s never been afraid of anything.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You think I’m a fool, Tommy? You think I’m just talking to hear myself speak?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced away, breath hissing out between his teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m telling you she doesn’t have her usual armour today,” Elizabeth drove on. “I’m telling you she’s vulnerable. And if you hurt her, Tommy…it would be very, very wrong.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I have no intention of hurting Sam,” he grated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She reached out and squeezed his arm. “I hope you take very great care not to. For your sake. And hers,” she said quietly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His gaze swung back, eyes blazing a fierce challenge. “You think it’s all my fault?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The banked passion behind those words told Elizabeth more than Tommy had ever told her…the long-burning frustration of his relationship with Samantha Connelly. But there was nothing to be gained by placing blame anywhere. Raking over the past wouldn’t help. She had to appeal to the man he was now, the man who still wanted what could be…if the ground was shifted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No,” she answered, her eyes holding his with love and understanding. “I simply trust you’re big enough…and I know you are, Tommy…to rise above it today. To give of yourself without asking or expecting a return or a reward. Just to give…because giving is what today is about.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("His mouth twisted into a wry smile. “Okay. You have a deal. For what it’s worth.” His eyes gently ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("mocked as he added, “But you must know Sam’s bound to make tatters of any gift from me.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then the fault will indeed be all hers. Thank you, Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Oh, I’ll be having the pleasure of being a martyred saint,” he rolled out in an Irish lilt, a resurgence of devilment in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She smiled. “Have I told you lately that I love you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His face softened. “You don’t have to. You’ve always been on my side when I’ve needed you. And to simply say thank you is totally inadequate. But thanks all the same, Mum.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Elizabeth had never had any hesitation in throwing family money behind Tommy’s enterprises, the small planes and helicopter charter business which he’d called KingAir, the wilderness resort that bore the same name as the cattle station, King’s Eden, since it had once been a part of it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He’d had a great need to prove himself, away from Nathan’s big shadow, Nathan who was born to be the cattle King and wear his father’s shoes. Tommy had to be his own man, and he was, very much his own man now, solidly successful in his business life.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But his personal life…he envied the love Nathan had found with Miranda. Elizabeth had seen it in his eyes on the night of their engagement party and knew he craved the same kind of love…to be accepted and respected and loved for the person he was inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Let’s have a happy day, Tommy,” she said, knowing he would respond to her appeal for peace with Samantha.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sure, we will. The happiest of days. Especially for Nathan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For you, too, Elizabeth willed. “I must go back to Miranda. Everything else is in order?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Running like clockwork. Don’t worry. We’re onto the countdown now and everything will go brilliantly.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I hope so.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He tapped her cheek in tender affection. “It’s all right. You have my promise. I’ll keep smiling in the face of the tiger.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Thank you, Tommy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was with a lighter heart that Elizabeth returned to the bride. She’d done what she could to set up a harmonious situation. What might come out of it was up to Tommy and Samantha now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bridesmaid and the best man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A wedding.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Surely they would feel what was missing from their lives and make an effort to leap over the barriers between them and grasp this chance. Pride simply wasn’t worth the loss of love.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ea69074","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459206717_ch02.vue
// module id = 72
// module chunks = 0